import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class WorkspaceLifeEventAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'workspace-life-event';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'workspaces/lives/events';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'id',
      'slug',
      'title',
      'description',
      'order',
      'isActive',
      'defaultSettings',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      id: {
        type: 'string',
        presence: true,
      },
      slug: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      title: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      description: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      isActive: {
        type:'boolean'
      },
      order: {
        type: 'integer',
      },
    };
  }

}

export default WorkspaceLifeEventAppResource;
